<div class="game-preview" *ngIf="data" [ngClass]="{'locked': !data.properties.isAvailable}" (click)="onStartClick()" [title]="data.properties.isAvailable ? '' : 'Demnächst verfügbar'">

  <div class="game-preview__locked-overlay" *ngIf="!data.properties.isAvailable">
    <brt-icon [icon]="'locked'" [add-blur]="true"></brt-icon>
  </div>

  <div class="game-preview__hover-overlay" *ngIf="data.properties.isAvailable">
    <brt-button [title]="'CLASS_DASHBOARD.PLAY_NOW' | translate" [color]="'white'" [add-blur]="true"></brt-button>
  </div>
  <div class="game-preview__image">
    <brt-lottie [lottieOptions]="{path: data.lottieSrc, autoplay: true, loop: true}" (instanceCreated)="onLottieInstanceCreated($event)" *ngIf="data.lottieSrc.length > 0; else elseImage"></brt-lottie>
    <ng-template #elseImage>
      <img [src]="data.imageSrc" [alt]="data.name"/>
    </ng-template>
  </div>
  <div class="game-preview__content">
    <div class="game-preview__name">
      <brt-item-tag [data]="nameItemTag"></brt-item-tag>
    </div>

    <div class="game-preview__tags">
      <div class="game-preview__tag" *ngFor="let tag of propertyTags">
        <brt-item-tag [data]="tag"></brt-item-tag>
      </div>
    </div>
  </div>
</div>
